/**
 * GERADO. Não edite à mão.
 *
 * Produzido por `packages/asset-pipeline/src/cards/emit-card-manifest.ts` a
 * partir dos masters em `assets-source/cards/`, que continuam a ser a única
 * fonte da arte.
 *
 * Regenerar:
 *
 *     pnpm assets:cards
 *
 * `emit-card-manifest.test.ts` compara este ficheiro com o que uma regeração
 * produziria: divergir é teste vermelho, e não uma surpresa em produção.
 *
 * Ele está FORA do Biome, como os manifestos de joias e de skins e pela mesma
 * razão: o formatador quer uma forma e este gerador emite `JSON.stringify`, e
 * reproduzir a formatação aqui criaria um segundo sítio onde a FORMA do ficheiro
 * é decidida - a brigar com a prova, que compara texto.
 *
 * As DEZASSEIS artes existem desde o gate V28I.AU, e cada entrada aqui é uma
 * delas: `cardArt` resolve as dezasseis, e continua a responder `null` a um
 * identificador que o catálogo não conhece — o recuo é para o DESCONHECIDO, e
 * nunca para uma carta que existe.
 *
 * O que uma entrada NÃO diz é o que a carta faz. Raridade, arrefecimento,
 * nível, efeito e modo são do catálogo, e nenhuma regra se lê destes pixels.
 */

import type { CardManifest } from './card-manifest';

export const GENERATED_CARD_MANIFEST = {
  "manifestVersion": 1,
  "entries": [
    {
      "cardId": "card_attack_break",
      "assetKey": "card_attack_break",
      "master": "card_attack_break.png",
      "masterSha256": "39d6f23c078086e941678348ff1d9d89ec6497e4a279d4a6c08246d76543c1f7",
      "masterWidth": 1024,
      "masterHeight": 1536,
      "file": "cards/card_attack_break.png",
      "sha256": "9ff5bc68a604fdaf5dbc547070ec526467bdf6f9385abf9d3555e7ac3fce56ab",
      "width": 512,
      "height": 768,
      "contentVersion": 2
    },
    {
      "cardId": "card_attack_drone",
      "assetKey": "card_attack_drone",
      "master": "card_attack_drone.png",
      "masterSha256": "07b4343ed0cc3ac473003f54e54e40a3114ed118f6d42e40a94642fbb5d74cd0",
      "masterWidth": 1024,
      "masterHeight": 1536,
      "file": "cards/card_attack_drone.png",
      "sha256": "0903fc29e1147d940bc2bf33157dd2133d9ddb6bbce9bdea27d55583395c7d72",
      "width": 512,
      "height": 768,
      "contentVersion": 2
    },
    {
      "cardId": "card_bastion",
      "assetKey": "card_bastion",
      "master": "card_bastion.png",
      "masterSha256": "92a4f932e86357836fe811ca7e1031ede5e8a8c75107a9e8f0346eabac11eb12",
      "masterWidth": 1024,
      "masterHeight": 1536,
      "file": "cards/card_bastion.png",
      "sha256": "9e51d1ccaf792a9d6c3c1e4dfd6f7e82904f3e5457238cbfe5ff078b1f6ddb31",
      "width": 512,
      "height": 768,
      "contentVersion": 2
    },
    {
      "cardId": "card_blade_storm",
      "assetKey": "card_blade_storm",
      "master": "card_blade_storm.png",
      "masterSha256": "8f4e4e97ff109938dd58745489d91b7b110986a3cf873768bc4c6b61b5ae6ef0",
      "masterWidth": 1024,
      "masterHeight": 1536,
      "file": "cards/card_blade_storm.png",
      "sha256": "ca4033e247cb3957e1170f7cc815cbd14fc592d5d56c97b75cb063537d6fd73a",
      "width": 512,
      "height": 768,
      "contentVersion": 2
    },
    {
      "cardId": "card_catole",
      "assetKey": "card_catole",
      "master": "card_catole.png",
      "masterSha256": "806e57fe70d5a2248582d7275adeee00544531fdde4e4949de740d208f5caa20",
      "masterWidth": 1024,
      "masterHeight": 1536,
      "file": "cards/card_catole.png",
      "sha256": "cbd136649726b75d0527c3ff207abb8a5ae24decc40cd227d3adf619719df438",
      "width": 512,
      "height": 768,
      "contentVersion": 2
    },
    {
      "cardId": "card_charged_fireball",
      "assetKey": "card_charged_fireball",
      "master": "card_charged_fireball.png",
      "masterSha256": "f17ad91db15c3bcf3fc7159f8289c1d34f1299cd43f6642e0a984569b68d5e92",
      "masterWidth": 1024,
      "masterHeight": 1536,
      "file": "cards/card_charged_fireball.png",
      "sha256": "d9d5de2174dba827e5765dd63cfeb3fbe96af617abadc9a510ee3b658ebba635",
      "width": 512,
      "height": 768,
      "contentVersion": 2
    },
    {
      "cardId": "card_cloak",
      "assetKey": "card_cloak",
      "master": "card_cloak.png",
      "masterSha256": "d534446895b156d51dc6822f5c41977918d8d32e7eeee9d5770fbba2c35a3edc",
      "masterWidth": 1024,
      "masterHeight": 1536,
      "file": "cards/card_cloak.png",
      "sha256": "b18c94eec773f4029fa2176ef00450890dc5d1f02a88cf4c0b9f91b57fc127ad",
      "width": 512,
      "height": 768,
      "contentVersion": 2
    },
    {
      "cardId": "card_damage_break",
      "assetKey": "card_damage_break",
      "master": "card_damage_break.png",
      "masterSha256": "9bc6f5eb63fbd0dd8817f365e6b3b31412ad2f4c589c2d7f9b2a95d85cda1f12",
      "masterWidth": 1024,
      "masterHeight": 1536,
      "file": "cards/card_damage_break.png",
      "sha256": "d2cd35625f1da3973a3a69c51481991e94e8ba5211deec0acf3dea65b871ac08",
      "width": 512,
      "height": 768,
      "contentVersion": 2
    },
    {
      "cardId": "card_dash",
      "assetKey": "card_dash",
      "master": "card_dash.png",
      "masterSha256": "0d4049e233493512d3b5a53c7bce7ea0a595ddcfd70c4e5b7a4d8f76f08dda63",
      "masterWidth": 1024,
      "masterHeight": 1536,
      "file": "cards/card_dash.png",
      "sha256": "577ef8bb7fbd85127de6995fcdf57264e530ea00dfe055d7957721bf811a33ab",
      "width": 512,
      "height": 768,
      "contentVersion": 2
    },
    {
      "cardId": "card_freeze",
      "assetKey": "card_freeze",
      "master": "card_freeze.png",
      "masterSha256": "147036c61103ad14b54363130b604e68c345a6031521aaef0b6dddc931b180d2",
      "masterWidth": 1024,
      "masterHeight": 1536,
      "file": "cards/card_freeze.png",
      "sha256": "4ac8dccef1ddedee6234c4096736ff2f4705f771d95db0585e59febc6885e171",
      "width": 512,
      "height": 768,
      "contentVersion": 2
    },
    {
      "cardId": "card_leviathan",
      "assetKey": "card_leviathan",
      "master": "card_leviathan.png",
      "masterSha256": "732fc3addba1de76b13cf7b950ea99383a037d0c6ecdd300566e1ff1dfa2f891",
      "masterWidth": 1024,
      "masterHeight": 1536,
      "file": "cards/card_leviathan.png",
      "sha256": "12939dbab70ae8ee4107f64365cb245e48fb6252d8619142848c1b305616a8ed",
      "width": 512,
      "height": 768,
      "contentVersion": 2
    },
    {
      "cardId": "card_malware",
      "assetKey": "card_malware",
      "master": "card_malware.png",
      "masterSha256": "232b7a1ba2b8a5b8075141220243aa3a9a380abea98d87019b4f5aea2c45a753",
      "masterWidth": 1024,
      "masterHeight": 1536,
      "file": "cards/card_malware.png",
      "sha256": "e9233744dcf0ee05e8859034fc803714edfe4befb32aec1bb2f5b28df6d12b47",
      "width": 512,
      "height": 768,
      "contentVersion": 2
    },
    {
      "cardId": "card_slow",
      "assetKey": "card_slow",
      "master": "card_slow.png",
      "masterSha256": "7993c28cf03c5db50179897caecb3c8947f7012543e0f29f261882f0565a66bd",
      "masterWidth": 1024,
      "masterHeight": 1536,
      "file": "cards/card_slow.png",
      "sha256": "cbe84aad0a84e39c67b80ee5060a3ce6b66258f1da5542632e89b15dc1257dcd",
      "width": 512,
      "height": 768,
      "contentVersion": 2
    },
    {
      "cardId": "card_solar_lance",
      "assetKey": "card_solar_lance",
      "master": "card_solar_lance.png",
      "masterSha256": "0db1d5d3f814f9adb737943dd9f8a246b2c7e219813e5671872ce8effcccd4fc",
      "masterWidth": 1024,
      "masterHeight": 1536,
      "file": "cards/card_solar_lance.png",
      "sha256": "0cb3f183f6757be90c042fba56122874de572f4f30e98c24f8283756e46e2183",
      "width": 512,
      "height": 768,
      "contentVersion": 2
    },
    {
      "cardId": "card_speed_burst",
      "assetKey": "card_speed_burst",
      "master": "card_speed_burst.png",
      "masterSha256": "442d67bc44b095635e1e09f75cdbae3a1602c88ed43c3f8388d4e92c076a8017",
      "masterWidth": 1024,
      "masterHeight": 1536,
      "file": "cards/card_speed_burst.png",
      "sha256": "c774e4519aa8935aa38ce500edffaf9442c0028dfbbb8445b21c8d95c2d2c44a",
      "width": 512,
      "height": 768,
      "contentVersion": 2
    },
    {
      "cardId": "card_super_cannons",
      "assetKey": "card_super_cannons",
      "master": "card_super_cannons.png",
      "masterSha256": "17ac8b24306cb9c43519614cd0c365a658048578fd78144c4f3a4eb2282da31d",
      "masterWidth": 1024,
      "masterHeight": 1536,
      "file": "cards/card_super_cannons.png",
      "sha256": "a36ca5e6536008e0751b8729c8d931b65659acba41f9e621144467a4aa121bfb",
      "width": 512,
      "height": 768,
      "contentVersion": 2
    }
  ]
} as const satisfies CardManifest;
